import { DepartmentFragment } from '@/modules/org-hierarchy/modules/departments/graphql/fragments/generated/Department';

export const getDepartmentFilterOption = (department: DepartmentFragment) => ({
  value: department.id,
  label: department.name,
});
